import React from 'react';
import { RectShape } from 'react-placeholder/lib/placeholders'

const MyCourseListPlaceHolder = (
  <div className="course-offering-placeholder mb-2">

    <div className='row'>
    <div className="col-11 col-sm-5 mb-5">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-11 col-sm-5 mb-5">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-11 col-sm-5 mb-5">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-11 col-sm-5 mb-5">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
  </div>

  </div>
);

export default MyCourseListPlaceHolder;
